<ng-http-loader [backgroundColor]="'#00a1de'"></ng-http-loader>
<router-outlet></router-outlet>